import { useState, useEffect, useCallback } from 'react';
import { weatherConfig } from '../config/sites';

export const useWeather = () => {
  const [weather, setWeather] = useState(null);
  const [weatherTestMode, setWeatherTestMode] = useState(null);

  // Fetch weather data
  const fetchWeather = useCallback(async () => {
    try {
      const { lat, lon, timezone } = weatherConfig.location;
      const url = `${weatherConfig.apiUrl}?latitude=${lat}&longitude=${lon}&current=temperature_2m,weather_code,cloud_cover&temperature_unit=fahrenheit&timezone=${timezone}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error('Weather fetch failed');

      const data = await response.json();
      setWeather({
        temperature: Math.round(data.current.temperature_2m),
        weatherCode: data.current.weather_code,
        cloudCover: data.current.cloud_cover
      });
    } catch (error) {
      console.error('Error fetching weather:', error);
    }
  }, []);

  // Weather test mode keyboard handler
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'w' || e.key === 'W') {
        setWeatherTestMode(prev => {
          if (prev === null) return 'clear';
          if (prev === 'clear') return 'cloudy';
          if (prev === 'cloudy') return 'rain';
          if (prev === 'rain') return 'snow';
          if (prev === 'snow') return 'thunderstorm';
          if (prev === 'thunderstorm') return 'all';
          return null;
        });
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  // Fetch weather on mount
  useEffect(() => {
    fetchWeather();
  }, [fetchWeather]);

  return { weather, weatherTestMode };
};
